import numtableLogo from '@/assets/brand/numtable/numtable-logo-color.svg';
import numtableLogoReverse from '@/assets/brand/numtable/numtable-logo-white.svg';
import numtableIcon from '@/assets/brand/numtable/numtable-icon.svg';
import numtableIconReverse from '@/assets/brand/numtable/numtable-icon-white.svg';
import procalendarLogo from '@/assets/brand/procalendar/procalendar-logo-color.svg';
import procalendarLogoReverse from '@/assets/brand/procalendar/procalendar-logo-white.svg';
import procalendarIcon from '@/assets/brand/procalendar/procalendar-icon.svg';
import procalendarIconReverse from '@/assets/brand/procalendar/procalendar-icon-white.svg';
import type { MessageKey } from '@/shared/i18n/messages';

/** The two faces of the same deploy. Never hardcode either name in a component. */
export type Brand = 'numtable' | 'procalendar';

export const BRAND_IDS = ['numtable', 'procalendar'] as const;

export interface BrandConfig {
  readonly id: Brand;
  /** Product name — used for <title> and the PWA manifest, never translated. */
  readonly name: string;
  readonly shortName: string;
  readonly host: string;
  readonly homeUrl: string;
  /** Wordmark for light surfaces. */
  readonly logo: string;
  /** Wordmark for dark surfaces. */
  readonly logoReverse: string;
  /** Square mark for light surfaces. */
  readonly icon: string;
  /** Square mark for dark surfaces. */
  readonly iconReverse: string;
  /** Folders under /public/brand — icons, manifest, og image. */
  readonly assetDir: string;
  /** i18n key for the one-line product description. */
  readonly taglineKey: MessageKey;
}

export const BRANDS: Readonly<Record<Brand, BrandConfig>> = {
  numtable: {
    id: 'numtable',
    name: 'Numtable',
    shortName: 'Numtable',
    host: 'numtable.com',
    homeUrl: 'https://numtable.com',
    logo: numtableLogo,
    logoReverse: numtableLogoReverse,
    icon: numtableIcon,
    iconReverse: numtableIconReverse,
    assetDir: '/brand/numtable',
    taglineKey: 'brand.numtable.tagline',
  },
  procalendar: {
    id: 'procalendar',
    name: 'Procalendar',
    shortName: 'Procalendar',
    host: 'procalendar.app',
    homeUrl: 'https://procalendar.app',
    logo: procalendarLogo,
    logoReverse: procalendarLogoReverse,
    icon: procalendarIcon,
    iconReverse: procalendarIconReverse,
    assetDir: '/brand/procalendar',
    taglineKey: 'brand.procalendar.tagline',
  },
};

export function isBrand(value: unknown): value is Brand {
  return value === 'numtable' || value === 'procalendar';
}
